import { NgModule } from "@angular/core";
import { ThematicSitesComponent } from "./thematic_sites.component";
import { CommonModule } from "@angular/common";



@NgModule({
  imports: [CommonModule],
  declarations: [ThematicSitesComponent],
  exports: [ThematicSitesComponent],

})
export class ThematicSitesModule {
  static component = ThematicSitesComponent
}